import { AccountPayableModel } from 'api-hooks/account-payable';
import React from 'react';

import { FormType } from '../components/form-type';

interface Props {
  accountPayable?: AccountPayableModel;
}

export default function useGetDefaultValues(props: Props) {
  const { accountPayable } = props;
  const defaultValues = React.useMemo<FormType>(
    () => ({
      transactionAt: accountPayable?.transactionAt ?? new Date(),
      tempTransactionAt: accountPayable?.transactionAt ?? new Date(),
      needApproval: false,
      // externalId: 'A',
      refId: accountPayable?.refId,
      number: accountPayable?.number ?? '',
      agentId: accountPayable?.agent.id ?? null,
      description: accountPayable?.description ?? '',
      paymentMethodId: accountPayable?.payment.paymentMethod.id ?? null,
      paymentMethod: accountPayable?.payment.paymentMethod.type ?? '',
      paymentItems: accountPayable?.payment.paymentItems
        ? accountPayable.payment.paymentItems.map((item) => ({
            isCheck: true,
            amount: item.amount,
            discount: item.discount,
            fee: item.fee,
            paidAmount: item.transactionable.paidAmount,
            purchaseId: item.transactionable.id,
            tax: item.tax,
            total: item.transactionable.total,
            invoiceNumber: item.transactionable.number,
            status: item.transactionable.status,
            purchaseRefId: item.transactionable.refId,
            dueAmount:
              item.transactionable.total - item.transactionable.paidAmount,
            dueDate: item.transactionable.dueDate,
            acl: item.transactionable.acl,
          }))
        : [],
      chequeNote: accountPayable?.payment.chequeNote
        ? {
            availableAt: accountPayable.payment.chequeNote.availableAt,
            issuedAt: accountPayable.payment.chequeNote.issuedAt,
            bankAccountId: accountPayable.payment.chequeNote.bankAccount.id,
            chequeGiroId: accountPayable.payment.chequeNote.chequeGiro.id,
            expiredAt: accountPayable.payment.chequeNote.expiredAt,
            referenceNumber: accountPayable.payment.chequeNote.referenceNumber,
          }
        : null,
      paymentableId: accountPayable?.payment.chequeNote?.id
        ? accountPayable.payment.chequeNote.chequeGiro.id
        : accountPayable?.payment.paymentable?.id
        ? accountPayable.payment.paymentable.id
        : null,
    }),
    [accountPayable],
  );

  return defaultValues;
}
